/**
 * CSV 单元格转义。
 * @param {*} s 原始值。
 * @returns {string} 转义后的单元格内容。
 */
function escapeCsvCell(s) {
    return `"${String(s ?? '').replace(/"/g, '""')}"`;
}

/**
 * 通用表格 CSV 导出（UTF-8 BOM，便于 Excel 正确显示中文）。
 * @param {Object} options 导出配置（headers、rows、filenamePrefix）。
 * @returns {void}
 */
export function exportTableCsv({ headers, rows, filenamePrefix = '导出明细' }) {
    if (!Array.isArray(headers) || headers.length === 0 || !Array.isArray(rows) || rows.length === 0) {
        return;
    }
    const lines = [headers, ...rows];
    const csv = `\uFEFF${lines.map((line) => line.map(escapeCsvCell).join(',')).join('\r\n')}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const ts = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
    a.download = `${filenamePrefix}_${ts}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

/**
 * 未评分数据批量打分失败明细导出。
 * @param {Array} failures 失败记录列表。
 * @returns {void}
 */
export function exportProduceScoreFailureCsv(failures) {
    if (!Array.isArray(failures) || failures.length === 0) {
        return;
    }
    exportTableCsv({
        headers: ['资产ID', '失败原因'],
        rows: failures.map((f) => [f.assetNo || '-', f.reason || '未知错误']),
        filenamePrefix: '未评分数据提交失败明细'
    });
}

/**
 * 批量创建失败明细导出为 CSV（UTF-8 BOM，便于 Excel 正确显示中文）。
 * @param {Array<{ folderName: string, err: string }>} failures 失败记录列表。
 * @param {string} [filenamePrefix] 下载文件名前缀。
 * @returns {void} 无返回值。
 */
export function exportBatchFailureCsv(failures, filenamePrefix = '批量创建资产失败明细') {
    if (!Array.isArray(failures) || failures.length === 0) {
        return;
    }
    exportTableCsv({
        headers: ['子文件夹名称', '失败原因'],
        rows: failures.map((f) => [f.folderName, f.err]),
        filenamePrefix
    });
}
